/*
 * Copyright (c) 2021 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import React from 'react';
import GlobalStore from '../../stores/GlobalStore/GlobalStore';
import {
  ForgeConnectIdentity,
  IForgeConnectFunctionProps
} from "../common/ForgeConnectIdentity";
import { DIYErrorPage } from "../common/DIYErrorPage";
import authConfig from '../../stores/GatewayManager/ADOpenIdConfig';
import AuthenticationContext from "adal-angular";
import forgeAxiosInstance
  from "../../stores/GatewayManager/ForgeAxiosInstance";
import './../../components/layout.scss';
import { useEffect, useState } from 'react';
import { observe } from 'mobx';
import featureFlagStore from '../../utils/FeatureFlags/APFeatureFlagsStore';
import GatewayIdentity from './GatewayIdentity';

export interface IGatewayIdentityAppProps {
  globalStore?: GlobalStore;
}

export const GatewayIdentityApp = (props: IGatewayIdentityAppProps) => {
  const [featureFlagInitialized, setFeatureFlagInitialized] = useState(false);

  useEffect(() => {
    /*observe(featureFlagStore.featureFlags, () => {
      setFeatureFlagInitialized(true);
    });*/
    featureFlagStore.init(() => setFeatureFlagInitialized(true));
  });

  if (featureFlagInitialized) {
    const { globalStore } = props;
    const forgeAuthConfig = authConfig.getInstance(globalStore!.envVariables);
    const authContext = new AuthenticationContext(forgeAuthConfig);
    forgeAxiosInstance.setTokenProviderContext(authContext);
    return <ForgeConnectIdentity
      provider={authContext} globalStore={globalStore}>
      {
        ({
          isAuthenticated,
          userInfo,
          error,
          login,
          logout
        }: IForgeConnectFunctionProps) => {
          return (isAuthenticated) ?
            <GatewayIdentity userInfo={{
              firstName: userInfo.profile['given_name'],
              lastName: userInfo.profile['family_name'],
              userPrincipalName: userInfo.profile['upn']
            }}
              logout={logout} /> :
            <div className='root'>
              <div className='application-container'>
                <div className='application-main-content'>
                  <DIYErrorPage errorTitle='Unable to authenticate...'
                    message={`${error}, Please refresh the page.`}
                    showSupportLink={false} />
                </div>
              </div>
            </div>
        }
      }
    </ForgeConnectIdentity>
  } else {
    return <div></div>;
  }

}



